import { useCurrentUser } from 'hooks/useCurrentUser';

export function useCartOrderLayout() {
    const { currentUser } = useCurrentUser();
    const shouldShowAuthNotification = currentUser ? !currentUser.moderated : false;

    return {
        shouldShowAuthNotification,
    }
}